import isEmpty from 'lodash/isEmpty';
import { useFormContext } from 'react-hook-form';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import {
  AlertsModalType,
  DestinationsFormValues,
  useAlertsModalContext,
  withDestinationsFormProvider,
} from '../../context';
import { useAddWebhook } from '../../hooks/useAddWebhook';
import { AddOrEditForm } from '../../components/AddOrEditForm';

export const ADD_WEBHOOK_MODAL_TEST_ID = 'add-webhook-modal';
export const ADD_WEBHOOK_BUTTON_TEST_ID = 'add-webhook-button';

export const AddWebhookModal = withDestinationsFormProvider(() => {
  const { closeModal } = useAlertsModalContext();
  const { addWebhook, isLoading } = useAddWebhook(() =>
    closeModal(AlertsModalType.AddWebhookModal),
  );

  const {
    formState: { errors },
    handleSubmit,
  } = useFormContext<DestinationsFormValues>();

  return (
    <Modal
      withPortal
      isModalOpen
      onClose={() => closeModal(AlertsModalType.AddWebhookModal)}
      id={ADD_WEBHOOK_MODAL_TEST_ID}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>New webhook</ModalHeader>

      <ModalBody>
        <AddOrEditForm />
      </ModalBody>

      <ModalFooter>
        <PrimaryButton
          data-test={ADD_WEBHOOK_BUTTON_TEST_ID}
          isDisabled={!isEmpty(errors)}
          isLoading={isLoading}
          onClick={handleSubmit((values) => addWebhook(values))}
          size={BUTTON_SIZES.LARGE}
        >
          Create webhook
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
});
